import React, { useCallback, useState } from 'react';

import { Grid, TableCell, TableRow } from '@material-ui/core';

import { IAward } from '../../../../../../store/admin/eventAwards/store';

import Button from '../../../../../../components/Button';

interface IAwardRowActions {
  award: IAward;
  newAward: IAward;
  editMode: boolean;
  newAwardRow?: boolean;
  onRemove: any;
  onSave: any;
  onToggleEditMode: () => void;
  toggleSetShowNewAwardRow?: () => void;
}

export const AwardRowActions = (props: IAwardRowActions) => {
  const {
    award,
    editMode,
    newAwardRow,
    newAward,
    onRemove,
    onSave,
    onToggleEditMode,
    toggleSetShowNewAwardRow
  } = props;

  const disableSaveButton = useCallback(() => {
    const { type, cash, user, points, scrip } = award;

    return newAwardRow
      ? !(type && user && (points || scrip || cash))
      : newAward.touched &&
          ((!newAward.cash && newAward.touched.cash) ||
            (!newAward.points && newAward.touched.points) ||
            (!newAward.scrip && newAward.touched.scrip));
  }, [award, editMode, newAward]);

  const [showConfirmRemove, setShowConfirmRemove] = useState(false);

  const toggleShowConfirmRemove = () => setShowConfirmRemove(!showConfirmRemove);

  const onClickSave = async () => {
    const response = await onSave();

    if (!response.errors) {
      onToggleEditMode();
    }
  };

  const onClickRemove = async () => {
    await onRemove(award.id)();

    toggleShowConfirmRemove();
    onToggleEditMode();
  };

  return editMode ? (
    <TableRow className="editable-row-actions">
      <TableCell colSpan={4} />
      <TableCell colSpan={2}>
        <Grid className="grid" container={true} spacing={2}>
          {(newAwardRow || showConfirmRemove) && (
            <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4} />
          )}

          {showConfirmRemove ? (
            <>
              <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4}>
                <Button
                  id="confirm-remove-button"
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={onClickRemove}
                >
                  Yes, Remove
                </Button>
              </Grid>
              <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4}>
                <Button color="primary" type="submit" onClick={toggleShowConfirmRemove}>
                  Don't Remove
                </Button>
              </Grid>
            </>
          ) : (
            <>
              <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4}>
                <Button
                  id="save-award-row-button"
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={onClickSave}
                  disabled={disableSaveButton()}
                >
                  Save
                </Button>
              </Grid>
              {!newAwardRow && onRemove && (
                <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4}>
                  <Button
                    id="remove-award-row-button"
                    variant="outlined"
                    color="primary"
                    type="submit"
                    onClick={toggleShowConfirmRemove}
                  >
                    Remove
                  </Button>
                </Grid>
              )}
              <Grid className="grid-item add-players-card-container" item={true} xs={12} md={4}>
                <Button
                  color="primary"
                  type="submit"
                  onClick={newAwardRow ? toggleSetShowNewAwardRow : onToggleEditMode}
                >
                  Cancel
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </TableCell>
    </TableRow>
  ) : (
    <></>
  );
};
